module.exports = __webpack_public_path__ + "img/employees.7a985e3f.svg";